import { PureComponent } from 'react';
import Routes from 'ContentUtils/Routes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ContentRoutes from 'ContentUtils/Routes';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ExternalLinkIcon } from 'foundations-assets';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import * as StatusCodes from 'ContentUtils/enums/HttpStatusCodes';
import { H2 } from 'foundations-components/transitional/components/H2';
import { SUCCEEDED } from 'ContentUtils/constants/RequestStatus';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `ContentComponents.cmv2.fields.baseResource.${suffix}`;
const buttonI18nkey = suffix => `ContentComponents.buttons.${suffix}`;
export default function withCreateResourceModal(type) {
  return Comp => {
    class WithCreateResourceModal extends PureComponent {
      constructor(props) {
        super(props);
        this.onCreateModalOpen = this.onCreateModalOpen.bind(this);
        this.onCreateModalClose = this.onCreateModalClose.bind(this);
        this.onResourceNameChange = this.onResourceNameChange.bind(this);
        this.onCreateResource = this.onCreateResource.bind(this);
        this.openResource = this.openResource.bind(this);
        this.openNewResource = this.openNewResource.bind(this);
        this.onConflictError = this.onConflictError.bind(this);
        this.createResourceURL = this.createResourceURL.bind(this);
        this.onClickAddButton = this.onClickAddButton.bind(this);
        this.setHasLoadedOptions = this.setHasLoadedOptions.bind(this);
        this.renderCreateNewFooter = this.renderCreateNewFooter.bind(this);
        this.resourceWindow = null;
        const hasAnyOptions = !!props.options.length;
        this.state = {
          isOpen: false,
          resourceName: '',
          hasConflictError: false,
          hasLoadedOptions: hasAnyOptions,
          hasAnyOptions,
          isCreating: false
        };
      }
      componentDidMount() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          loadOptions
        } = this.props;
        if (!hasAnyOptions) {
          loadOptions('', this.setHasLoadedOptions);
        }
      }
      componentDidUpdate() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          options
        } = this.props;
        if (!hasAnyOptions && options.length) {
          this.setState({
            hasAnyOptions: true
          });
        }
      }
      setHasLoadedOptions() {
        this.setState({
          hasLoadedOptions: true
        });
      }
      onCreateModalOpen() {
        this.setState({
          isOpen: true,
          isCreating: false
        });
      }
      onCreateModalClose() {
        this.setState({
          isOpen: false,
          isCreating: false,
          resourceName: ''
        });
      }
      onResourceNameChange(evt) {
        this.setState({
          resourceName: evt.target.value
        });
        if (this.state.hasConflictError) {
          this.setState({
            hasConflictError: false
          });
        }
      }
      onConflictError() {
        this.setState({
          hasConflictError: true,
          isCreating: false
        });
      }
      createResourceURL(value) {
        switch (type) {
          case FieldTypes.FORM:
            return ContentRoutes.forms(value, this.props.redirectUrl);
          case FieldTypes.WORKFLOW:
            return ContentRoutes.workflows(value);
          case FieldTypes.FOLLOW_UP_EMAIL:
            return ContentRoutes.edit(value, 2);
          case FieldTypes.MENU:
            return ContentRoutes.advancedMenuSettings(value);
          default:
            return null;
        }
      }
      openResource() {
        return window.open(this.createResourceURL(this.props.value));
      }
      openNewResource(newId) {
        this.resourceWindow.location = this.createResourceURL(newId);
      }
      onCreateResource() {
        this.setState({
          isCreating: true
        });
        if (this.props.onCreateResource) {
          this.props.onCreateResource(this.state.resourceName, {
            onCreateModalClose: this.onCreateModalClose,
            onConflictError: this.onConflictError
          });
          return;
        }
        this.resourceWindow = this.openResource();
        this.props.createResource(this.state.resourceName).then(result => {
          if (result) {
            if (result.status === StatusCodes.CONFLICT) {
              this.onConflictError();
              return;
            }
            const newResourceId = result.id;
            if (newResourceId) {
              this.props.onFieldChange(newResourceId);
              this.openNewResource(newResourceId);
              this.onCreateModalClose();
            } else if (this.resourceWindow) {
              this.resourceWindow.close();
            }
          }
        }).catch(err => {
          setTimeout(() => {
            throw err;
          });
        });
      }
      onClickAddButton() {
        if (this.props.onClickAddButton) {
          this.props.onClickAddButton();
        }
        if (this.props.createResourceUrl) {
          window.open(this.props.createResourceUrl);
        } else {
          this.onCreateModalOpen();
        }
      }
      getResourceTypeLabel(count = 1) {
        return I18n.text(i18nKey(`typeLabels.${type}`), {
          count
        });
      }
      renderCreateResourceModal() {
        const {
          external
        } = this.props;
        const {
          isOpen,
          resourceName,
          hasConflictError
        } = this.state;
        if (!isOpen) return null;
        const typeLabel = this.getResourceTypeLabel();
        const conflictErrorMessage = hasConflictError && /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('conflictErrorMessage'),
          options: {
            type: typeLabel
          }
        });
        return /*#__PURE__*/_jsxs(Modal, {
          children: [/*#__PURE__*/_jsxs(DialogHeader, {
            children: [/*#__PURE__*/_jsx(DialogCloseButton, {
              onClick: this.onCreateModalClose
            }), /*#__PURE__*/_jsx(H2, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('create'),
                options: {
                  type: typeLabel
                }
              })
            })]
          }), /*#__PURE__*/_jsx(DialogBody, {
            children: /*#__PURE__*/_jsx(FormControl, {
              error: hasConflictError,
              validationMessage: conflictErrorMessage,
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('name')
              }),
              children: /*#__PURE__*/_jsx(TextInput, {
                value: resourceName,
                onChange: this.onResourceNameChange
              })
            })
          }), /*#__PURE__*/_jsxs(DialogFooter, {
            children: [/*#__PURE__*/_jsx(LoadingButton, {
              loading: this.state.isCreating,
              disabled: !resourceName,
              onClick: this.onCreateResource,
              use: "primary",
              children: /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                gap: "100",
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: buttonI18nkey('create')
                }), external ? /*#__PURE__*/_jsx(ExternalLinkIcon, {
                  size: "300"
                }) : null]
              })
            }), /*#__PURE__*/_jsx(Button, {
              onClick: this.onCreateModalClose,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: buttonI18nkey('cancel')
              })
            })]
          })]
        });
      }
      renderCreateNewFooter() {
        return Routes.isUngated('CMv2:SelectResourceActionsUpdates') && /*#__PURE__*/_jsx(Button, {
          onClick: this.onClickAddButton,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('add')
          })
        });
      }
      renderEditAddControls() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          addTooltip,
          disableAdd,
          disabled,
          disableEdit,
          editTooltip,
          external,
          onEditResource,
          value
        } = this.props;
        let editButton;
        if (hasAnyOptions) {
          editButton = /*#__PURE__*/_jsx(Button, {
            "data-selenium": "edit-resource-button",
            use: "tertiary-light",
            disabled: !value || disabled || disableEdit,
            onClick: onEditResource || this.openResource,
            size: "extra-small",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "100",
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: buttonI18nkey('edit')
              }), external ? /*#__PURE__*/_jsx(ExternalLinkIcon, {
                size: "100"
              }) : null]
            })
          });
          if (editTooltip) {
            editButton = /*#__PURE__*/_jsx(Tooltip, {
              title: editTooltip,
              placement: "top right",
              children: editButton
            });
          }
        }
        let addButton = (!Routes.isUngated('CMv2:SelectResourceActionsUpdates') || !hasAnyOptions) && /*#__PURE__*/_jsx(Button, {
          "data-selenium": "create-resource-button",
          disabled: disabled || disableAdd,
          marginInlineStart: editButton ? '200' : undefined,
          use: "tertiary-light",
          onClick: this.onClickAddButton,
          size: "extra-small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(hasAnyOptions ? 'add' : 'firstAdd'),
            options: {
              type: this.getResourceTypeLabel()
            }
          })
        });
        if (addButton && addTooltip) {
          addButton = /*#__PURE__*/_jsx(Tooltip, {
            title: addTooltip,
            placement: "top right",
            children: addButton
          });
        }
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(View, {
            marginBlockStart: "200",
            as: "div",
            children: [editButton, addButton]
          }), this.renderCreateResourceModal()]
        });
      }
      renderComponent() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          optionsRequestStatus
        } = this.props;
        if (optionsRequestStatus === SUCCEEDED && !hasAnyOptions) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('emptyMessage'),
            options: {
              type: this.getResourceTypeLabel(2)
            }
          });
        }
        return /*#__PURE__*/_jsx(Comp, Object.assign({}, this.props, {
          createNewFooter: this.renderCreateNewFooter()
        }));
      }
      render() {
        const {
          hasLoadedOptions
        } = this.state;
        if (!hasLoadedOptions) return /*#__PURE__*/_jsx(LoadingSpinner, {
          layout: "centered",
          grow: true
        });
        return /*#__PURE__*/_jsxs("div", {
          children: [this.renderComponent(), this.renderEditAddControls()]
        });
      }
    }
    WithCreateResourceModal.defaultProps = {};
    WithCreateResourceModal.displayName = 'WithCreateResourceModal';
    return WithCreateResourceModal;
  };
}